import React from 'react';
import { useAppSelector } from '../../../redux/hooks';
import { rootState } from '../../../redux/store';
import { TColorRole, TSize, colorMap } from '../../../types/types';
import { hexToRgb } from '../../../utils/hexToRgb';
import { getColorForUserInfo } from './utils/generateAvatarColor';

interface IAvatarLogoProps {
    color?: TColorRole;
    size?: TSize;
    userName: string;
    userSurname: string;
}

export const AvatarLogo: React.FC<IAvatarLogoProps> = ({ color = 'grey-dark', size = 'm', userName, userSurname }) => {
    const hexColor = getColorForUserInfo(`${userName}${userSurname}`);
    const { r, g, b } = hexToRgb(hexColor);

    return (
        <div className={`avatar-logo avatar-logo-${size}`} style={{ backgroundColor: `rgba(${r}, ${g}, ${b}, 1)`, border: `2px solid ${hexColor}` }}>
            <div className={`avatar-logo__letter avatar-logo__letter-${size}`}>
                {userName[0]}
                {userSurname[0]}
            </div>
        </div>
    );
};

// export const AvatarLogo:React.FC<IAvatarLogoProps> = ({color = 'grey-dark', size='m'})=>{
//     const {userAndTokenData} = useAppSelector((state:rootState) => state.loginUserAndTokenData)
//     const hexColor = colorMap[color] || colorMap['grey-dark']
//     const {r, g, b} = hexToRgb(hexColor);

//     const userColor = getColorForUserInfo(`${userAndTokenData?.user.name}${userAndTokenData?.user.surname}`);

//     return (
//         <div className={`avatar-logo avatar-logo-${size}`} style={{backgroundColor:`rgba(${r}, ${g}, ${b}, 1)`, border: `2px solid ${hexColor}`}}>
//             <div className={`avatar-logo__letter avatar-logo__letter-${size}`}>{userAndTokenData?.user.name[0]}{userAndTokenData?.user.surname[0]}</div>
//         </div>
//     )
// }
